/* Lafermu shared calendar: national + Comunidad de Madrid only, no local holidays.
   Official sources and annual maintenance: CALENDARIO.txt in the delivery package. */
(() => {
  'use strict';
  const holidaysByYear = {
    2026: ['01-01','01-06','04-02','04-03','05-01','05-02','08-15','10-12','11-02','12-07','12-08','12-25'],
    2027: ['01-01','01-06','03-19','03-25','03-26','05-01','08-16','10-12','11-01','12-06','12-08','12-25']
  };
  function createCalendar(years) {
    const holidays = new Set(Object.entries(years).flatMap(([year, days]) => days.map(day => `${year}-${day}`)));
    const iso = date => date.toISOString().slice(0,10);
    function isWorkingDay(date) {
      if (!Object.hasOwn(years, date.getUTCFullYear())) throw new RangeError('CALENDAR_YEAR_MISSING');
      return date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !holidays.has(iso(date));
    }
    function today(now, timeZone = 'Europe/Madrid') {
      const p = new Intl.DateTimeFormat('en-CA',{timeZone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
      const part = type => Number(p.find(x => x.type === type).value);
      return Date.UTC(part('year'),part('month')-1,part('day'));
    }
    function addBusinessDays(timestamp, days) {
      if (!Number.isSafeInteger(days) || days < 0 || days > 36503) throw new RangeError('INVALID_LEAD');
      const date = new Date(timestamp);
      isWorkingDay(date); // Check coverage even when the start is a weekend.
      let remaining = days;
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate()+1);
        if (isWorkingDay(date)) remaining--;
      }
      while (!isWorkingDay(date)) date.setUTCDate(date.getUTCDate()+1);
      return date;
    }
    const safe = fn => { try { return fn(); } catch(error) { if(error instanceof RangeError) return null; throw error; } };
    const format = (date, short = false, year = false) => new Intl.DateTimeFormat('es-ES', {
      weekday:'long',day:'numeric',...(short?{}:{month:'long'}),...(year?{year:'numeric'}:{}),timeZone:'UTC'
    }).format(date).replace(',', '');
    function pickupDate(days, now = new Date(), timeZone = 'Europe/Madrid') {
      return safe(() => { const date=addBusinessDays(today(now,timeZone),days); return {date:iso(date),text:format(date,false,true)}; });
    }
    function deliveryWindow(days, now = new Date(), timeZone = 'Europe/Madrid') {
      return safe(() => {
        if (!Number.isSafeInteger(days) || days < 0 || days > 36500) throw new RangeError('INVALID_LEAD');
        const base=today(now,timeZone), start=addBusinessDays(base,days+2),end=addBusinessDays(base,days+3);
        const crossYear=start.getUTCFullYear()!==end.getUTCFullYear();
        const sameMonth=!crossYear&&start.getUTCMonth()===end.getUTCMonth();
        return {start:iso(start),end:iso(end),text:`${format(start,sameMonth,crossYear)} y el ${format(end,false,crossYear)}`};
      });
    }
    function expressDelivery(now = new Date(), timeZone = 'Europe/Madrid') {
      return safe(() => {
        const base=today(now,timeZone);
        const hour=Number(new Intl.DateTimeFormat('en-GB',{timeZone,hour:'2-digit',hourCycle:'h23'}).format(now));
        const beforeCutoff=isWorkingDay(new Date(base))&&hour<12;
        const dispatch=beforeCutoff?new Date(base):addBusinessDays(base,1);
        const delivery=addBusinessDays(dispatch.getTime(),1);
        return {date:iso(delivery),beforeCutoff,text:beforeCutoff
          ? `Si pides antes de las 12:00, recíbelo el ${format(delivery)} antes de las 14:00.`
          : `Si pides antes de las 12:00 del ${format(dispatch)}, recíbelo el ${format(delivery)} antes de las 14:00.`};
      });
    }
    return {pickupDate,deliveryWindow,expressDelivery,addBusinessDays,isWorkingDay,today};
  }
  const api = {...createCalendar(holidaysByYear),createCalendar,holidaysByYear};
  if (typeof module !== 'undefined' && module.exports) { module.exports=api; return; }
  globalThis.LafermuCalendar = api;
  if (customElements.get('cro-collection-availability')) return;
  class CollectionAvailability extends HTMLElement {
    connectedCallback() {
      this.render();
      this.timer=setInterval(()=>{if(!document.hidden)this.render();},60000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
    render(){
      const output=this.querySelector('[data-listing-date]');
      if(!output) return;
      const state=this.dataset.state;
      const raw=this.dataset.lead, days=state==='stock'?0:raw===''?null:Number(raw);
      let message='';
      if(state==='stock'||state==='manufacturing') {
        if(this.dataset.mixed==='true') message='Consulta entrega según variante';
        else if(!Number.isSafeInteger(days)||days<0||days>36500) message='Consulta el plazo de entrega';
        else {
          const window=api.deliveryWindow(days);
          message=window ? `${state==='stock'?'Recíbelo':'Entrega estimada'} entre el ${window.text}.` : 'Consulta la fecha de entrega';
        }
      }
      output.textContent=message;
      output.hidden=!message;
    }
  }
  customElements.define('cro-collection-availability',CollectionAvailability);
})();
